import { useEffect } from 'react';

import Geocode from 'react-geocode';

import { parseLatLngFromString, getAddressByCoords, getCoordsByAddress, formatCoord, isValidCoords } from 'utils/maps';

const apiKey = process.env.REACT_APP_GOOGLE_MAP;

export function useGoogleMaps({ onChangeCoords, onChangeAddress }) {
  const handleChangeAddress = (value) => {
    getCoordsByAddress(value).then(onChangeCoords);
  };

  const handleChangeCoords = async (event) => {
    const value = event.target.value;

    if (isValidCoords(value)) {
      const latLng = parseLatLngFromString(value);
      const address = await getAddressByCoords(latLng);

      onChangeAddress(address);

      return onChangeCoords(latLng);
    }
  };

  const handleClickMap = (e, map, clickEvent) => {
    const coords = {
      lat: formatCoord(clickEvent.latLng.lat()),
      lng: formatCoord(clickEvent.latLng.lng()),
    };

    onChangeCoords(coords);
    getAddressByCoords(coords).then(onChangeAddress);
  };

  useEffect(() => {
    Geocode.setApiKey(apiKey);
  }, []);

  return {
    handleChangeAddress,
    handleChangeCoords,
    handleClickMap,
  };
}
